import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-reservacion-table',
  templateUrl: './reservas-table.component.html',
  styleUrls: ['./reservas-table.component.scss']
})
export class ReservacionTableComponent {

  @Input() public historyReservations: any;

  constructor() {
  }
}
